import React from 'react';

import { ThemeOptions } from '@mui/material/styles/createTheme';
import { TypographyVariant as MuiTypographyVariant } from '@mui/material/styles/createTypography';

export type TypographyVariant = MuiTypographyVariant | 'display1' | 'body' | 'bodyMd' | 'bodySm' | 'bodyXs' | 'input';

declare module '@mui/material/styles' {
    interface TypographyVariants {
        display1: React.CSSProperties;
        body: React.CSSProperties;
        bodyMd: React.CSSProperties;
        bodySm: React.CSSProperties;
        bodyXs: React.CSSProperties;
        input: React.CSSProperties;
    }

    // allow configuration using `createTheme`
    interface TypographyVariantsOptions {
        display1?: React.CSSProperties;
        body?: React.CSSProperties;
        bodyMd?: React.CSSProperties;
        bodySm?: React.CSSProperties;
        bodyXs?: React.CSSProperties;
        input?: React.CSSProperties;
    }
}

declare module '@mui/material/styles/createTypography' {
    interface TypographyVariants {
        display1: React.CSSProperties;
        body: React.CSSProperties;
        bodyMd: React.CSSProperties;
        bodySm: React.CSSProperties;
        bodyXs: React.CSSProperties;
        input: React.CSSProperties;
    }

    // allow configuration using `createTheme`
    interface TypographyVariantsOptions {
        display1?: React.CSSProperties;
        body?: React.CSSProperties;
        bodyMd?: React.CSSProperties;
        bodySm?: React.CSSProperties;
        bodyXs?: React.CSSProperties;
        input?: React.CSSProperties;
    }
}

declare module '@mui/material/Typography' {
    interface TypographyPropsVariantOverrides {
        display1?: true;
        body?: true;
        bodyMd?: true;
        bodySm?: true;
        bodyXs?: true;
        input?: true;
    }
}

export const CUSTOM_TYPOGRAPHY: ThemeOptions['typography'] = {
    fontFamily: 'Inter',
    htmlFontSize: 10,
    fontWeightMedium: 500, // no funciona es 400
    fontWeightBold: 700,
    display1: {
        fontSize: '2.4rem',
        lineHeight: '3.12rem',
        fontWeight: 'bold',
    },
    h1: {
        fontSize: '1.8rem',
        lineHeight: '2.34rem',
        fontWeight: 'bold',
    },
    h2: {
        fontSize: '1.6rem',
        lineHeight: '2.4rem',
        fontWeight: 'bold',
    },
    h3: {
        fontSize: '1.4rem',
        lineHeight: '2.1rem',
        fontWeight: 'bold',
    },
    h4: {
        fontSize: '1.4rem',
        lineHeight: '1.82rem',
        fontWeight: 'bold',
    },
    h5: {
        fontSize: '1.1rem',
        lineHeight: '1.43rem',
        fontWeight: 'bold',
    },
    h6: {
        fontSize: '1.2rem',
        lineHeight: '1.5rem',
        fontWeight: 'bold',
    },
    body: {
        fontSize: '1.2rem',
        lineHeight: '1.8rem',
        fontWeight: 'medium',
    },
    body1: {
        fontSize: '1.2rem',
        lineHeight: '1.8rem',
        fontWeight: '500',
    },
    bodyMd: {
        fontSize: '1.1rem',
        lineHeight: '1.65rem',
        fontWeight: 'medium',
    },
    bodySm: {
        fontSize: '1.0rem',
        lineHeight: '1.4rem',
        fontWeight: 'medium',
    },
    bodyXs: {
        fontSize: '.9rem',
        lineHeight: '1.1rem',
        fontWeight: 'medium',
    },
    input: {
        fontSize: '1.3rem',
        lineHeight: '1.7rem',
        fontWeight: '600',
        letterSpacing: '0.02rem',
    },
};
